export function formatGradeOpinion(difficulty: string | null | undefined, opinion: number): string {
  const digit = Math.round(opinion * 10);
  return difficulty ? `${difficulty}.${digit}` : `.${digit}`;
}
